import './jquery.menu-aim'

// перенос в верхнюю часть страницы
$(document).ready(function() {
    $('.js-header-catalog').append($('.js-catalog-menu'));
    loadAndResizeEvents();
});

$(window).resize(loadAndResizeEvents);

function loadAndResizeEvents() {
    var clientWidth = document.documentElement.clientWidth;

    if(clientWidth >= 1200) {
        var leftNavigation = $('.js-left-navigation');
        var leftNavigationDiv = $('.js-left-navigation > div');
        var mainContentH = $('#main-content').height();
        var mainContentW = $('#main-content').width();

        //var clientHeight = document.documentElement.clientHeight;
        //var containerHeight = $('main > div > div.uk-container').height();

        var containerHeightReal = $('main > div > div.uk-container > div').height();

        var offsetTop = containerHeightReal-mainContentH;

        var leftNavigationWidth = (clientWidth-mainContentW)/2 - 20;

        if(leftNavigationWidth < 230 && clientWidth >= 1600) {
            leftNavigation.width(parseInt(leftNavigationWidth-parseFloat(leftNavigation.css('padding-left'))));
        }else {
            leftNavigation.width(230-parseFloat(leftNavigation.css('padding-left')));
        }

        leftNavigation.css({ top: offsetTop +'px', left: (clientWidth-mainContentW)/2 - parseFloat($('#main-content').css('padding-left')) - leftNavigation.width() - parseFloat(leftNavigation.css('padding-left'))});

        leftNavigationDiv.css({ 'max-height': mainContentH});

        if(document.querySelector('.js-left-navigation .tm-navigation-ul-block li.uk-active')){
            $('.js-left-navigation .tm-navigation-ul-block').animate({ scrollTop: ($('.js-left-navigation .tm-navigation-ul-block').scrollTop() + $('.js-left-navigation .tm-navigation-ul-block li.uk-active').position().top - 390) }, 0);
        }
    }
}


// задержка при движении в меню
$(function() {

    $('.js-catalog-menu__nav').menuAim({
        activateCallback:   activate,
        deactivateCallback: deactivate,
        openClassName:      '.is-hover',
        activationDelay:    0
    });

    function activate(row) {
        var container = $('.js-nav-container').width(),
            menu = $('.js-catalog-menu').width();
        $(row).addClass('is-hover').find('.js-catalog-menu__popup.last-nav').width((container - menu - 400));
    }

    function deactivate(row) {
        $(row).removeClass('is-hover');
    }

});

// задержка при наведении на кнопку меню, затемнение страницы
$(function () {
    var header = $('.js-header-catalog');
    header.on('mouseover', function() {

        var jt = $(this),
            menu = $('.js-catalog-menu');

        if (!jt.hasClass('is-always-open')) {
            var openCatalog = setTimeout(function() {
                menu.show();
                header.addClass('is-hover');
            }, 200);
            jt.one('mouseout', function () {
                clearTimeout(openCatalog);
                var closeCatalog = setTimeout(function() {
                    menu.hide();
                    header.removeClass('is-hover');
                }, 0);
                jt.one('mouseover', function () {
                    clearTimeout(closeCatalog);
                });
            });
        }

    });
});



// WEBPACK FOOTER //
// ./assets/js/menu.js